import { Box, Button, Link, Stack, Typography } from '@customink/pigment-react';
import { useConfigContext } from '@customink/project-service-react-components';

import { Satisfaction } from './LineItem/Satisfaction';

import cartIcon from '@/assets/cart.svg';
import { useAuth } from '@/contexts/auth/AuthContext';

export function EmptyCart() {
  const hostName = useConfigContext().ciHostname;
  const { user } = useAuth();
  const loggedIn = !!user?.isLoggedIn;

  return (
    <Stack>
      <Typography margin="24px 0 16px 0" variant="heading1">
        My Cart
      </Typography>
      <Stack
        alignItems="center"
        sx={{
          borderRadius: '8px',
          border: '1px solid #e3e3e3',
          padding: { sm: '48px 32px', md: '64px' },
          marginBottom: '16px',
          backgroundColor: 'white',
        }}
      >
        <Stack data-testid="empty-cart">
          <Stack
            sx={{
              alignItems: 'center',
              marginBottom: { sm: '20px', md: '24px' },
            }}
          >
            <img
              alt="chat with a representative"
              src={cartIcon}
              style={{
                width: '36px',
                height: '36px',
                marginBottom: '20px',
                opacity: 0.56,
              }}
            />
            <Typography sx={{ marginBottom: '5px' }} variant="heading3">
              Your cart is empty
            </Typography>
            <Typography
              fontSize={{ sm: '0.9em', md: '1em' }}
              textAlign="center"
            >
              What would you like to create today?
            </Typography>
          </Stack>
          <Stack
            alignItems="center"
            direction={{ sm: 'column', md: 'row' }}
            justifyContent="center"
            sx={{ gap: '12px', marginBottom: '24px' }}
          >
            <Button
              href={`${hostName}/products`}
              size="large"
              sx={{ width: '180px' }}
            >
              Browse Products
            </Button>
            <Button
              href={`${hostName}/ndx/#/welcomeBack`}
              size="large"
              sx={{ width: '180px' }}
              variant="secondary"
            >
              Start designing
            </Button>
          </Stack>
          <Box textAlign="center">
            {loggedIn ? (
              <Link href={`${hostName}/account/designs`}>
                View saved designs
              </Link>
            ) : (
              <>
                Have a saved design?{' '}
                <Link href={`${hostName}/profiles/users/sign_in`}>Sign in</Link>
              </>
            )}
          </Box>
        </Stack>
      </Stack>
      <Satisfaction />
    </Stack>
  );
}
